import React, { useState } from "react";
import { useDispatch } from "react-redux";
import allActions from "./../state/items/actions/index";

import {
  TextField,
  Card,
  CardHeader,
  CardActions,
  Button,
  FormControl,
  Typography,
} from "@mui/material";

import { useTheme } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";

// ✅ Utilisation du module par défaut
import { Auth } from "aws-amplify";

const AuthLogin = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();

  // Styles JS utilisant le thème
  const styles = {
    root: {
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundImage:
        "url('https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1920&q=80')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      position: "relative",
      padding: "20px",
    },
    overlay: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background:
        "linear-gradient(135deg, rgb(251 251 251 / 85%) 0%, rgb(75 119 162 / 85%) 100%)",
      zIndex: 0,
    },
    titleTop: {
      padding: 20,
    },
    header: {
      backgroundColor: "transparent",
      color: theme.palette?.primary.main,
      textAlign: "center",
      fontSize: "1.5rem",
      fontWeight: 600,
      padding: "30px 20px 10px",
    },
    container: {
      margin: "0 auto",
      background: "rgba(255, 255, 255, 0.98)",
      backdropFilter: "blur(20px)",
      maxWidth: 460,
      width: "100%",
      borderRadius: 20,
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      position: "relative",
      zIndex: 1,
      overflow: "hidden",
    },
    formContainer: {
      padding: "0 30px 30px",
    },
    marginTop: {
      marginTop: 20,
      width: "100%",
      padding: "12px",
      borderRadius: "8px",
      textTransform: "none",
      fontSize: "1rem",
      fontWeight: 600,
    },
    demo: {
      margin: "20px auto",
      display: "block",
      textAlign: "center",
      paddingBottom: "20px",
    },
    demolink: {
      textDecoration: "none",
      color: theme.palette?.primary.main,
      background: "transparent",
      padding: "8px 16px",
      borderRadius: "8px",
      border: `1px solid ${theme.palette?.primary.main}`,
      transition: "all 0.3s ease",
      fontWeight: 500,
    },
    actions: {
      display: "flex",
      justifyContent: "center",
      marginTop: 0,
      padding: "20px 30px",
      borderTop: "1px solid #e5e7eb",
    },
    link: {
      color: theme.palette?.primary.main,
      padding: "0",
      textDecoration: "none",
      fontWeight: 600,
    },
    error: {
      color: "#ef4444",
      padding: "10px 30px",
      fontSize: "0.875rem",
    },
    forgotPassword: {
      marginTop: 15,
      textAlign: "center",
      fontSize: "0.875rem",
    },
  };

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState([]);

  const handleLogin = async () => {
    setError([]);
    setSubmitting(true);
    try {
      const user = await Auth.signIn({ username, password });

      if (user) {
        dispatch(allActions.itemActions.setUser(user.attributes));
        setSubmitting(false);
        navigate("/", { replace: true });
      }
    } catch (error) {
      setSubmitting(false);
      setError([error.message || error.code]);
    }
  };

  return (
    <div style={styles.root}>
      <div style={styles.overlay}></div>
      <Card style={styles.container} elevation={0}>
        <CardHeader
          style={styles.header}
          title="Kadomi.Shop"
          subheader="Connexion à votre compte"
          disableTypography={false}
          titleTypographyProps={{
            style: {
              fontSize: "1.75rem",
              fontWeight: 700,
              color: theme.palette?.primary.main,
            },
          }}
          subheaderTypographyProps={{
            style: { fontSize: "0.95rem", color: "#6b7280", marginTop: "5px" },
          }}
        />
        <div style={styles.formContainer}>
          <form noValidate autoComplete="off">
            <FormControl fullWidth>
              <TextField
                label="Nom d'utilisateur ou E-mail"
                margin="normal"
                placeholder="Saisissez votre nom d'utilisateur"
                onChange={(e) => setUsername(e.target.value)}
                variant="outlined"
                value={username}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                label="Mot de passe"
                type="password"
                margin="normal"
                placeholder="Saisissez votre mot de passe"
                onChange={(e) => setPassword(e.target.value)}
                variant="outlined"
                value={password}
              />
            </FormControl>
          </form>
          <Button
            style={styles.marginTop}
            variant="contained"
            disabled={submitting || password === "" || username === ""}
            onClick={handleLogin}
            fullWidth
          >
            {submitting ? "Connexion en cours..." : "Se connecter"}
          </Button>
          <Typography style={styles.forgotPassword}>
            Mot de passe oublié ?{" "}
            <Link style={styles.link} to="/recover-password">
              Réinitialiser
            </Link>
          </Typography>
        </div>
        {error.length > 0 &&
          error.map((e, key) => (
            <Typography style={styles.error} key={key}>
              ⚠️ {e}
            </Typography>
          ))}
        {false ? (
          <CardActions style={styles.actions}>
            <Typography variant="body2">
              Pas encore de compte ?{" "}
              <Link style={styles.link} to="/register">
                Créer un compte
              </Link>
            </Typography>
          </CardActions>
        ) : null}
        <div style={styles.demo}>
          <a
            style={styles.demolink}
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.youtube.com/watch?v=8nhvKZaY53I"
          >
            Voir une démo
          </a>
        </div>
      </Card>
    </div>
  );
};

export default AuthLogin;
